import React from "react";
import { PatientAdvancedDirective } from "../messages";
import { formatPhone } from "../phone_number";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { fmap } from "../utils/fmap";
import { AppCard, AppCardHeader, AppCardTitle, AppCardContent } from "./Generic/AppCard";
import { AppList, AppListItem } from "./Generic/AppList";
import PatientDetailsNoValue from "./Patient/components/PatientDetailsNoValue";

interface Props {
  advancedDirectives: PatientAdvancedDirective;
}

export const PatientDirectivesCard = (props: Props) => {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{translate(STRINGS.ADVANCED_DIRECTIVES)}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>
          <AppListItem
            title={<strong>{translate(STRINGS.HAS_DNR)}</strong>}
            trailing={
              props.advancedDirectives.hasDNR === true
                ? translate(STRINGS.YES)
                : translate(STRINGS.NO)
            }
          />
          <AppListItem
            title={<strong>{translate(STRINGS.HAS_HEALTH_CARE_PROXY)}</strong>}
            trailing={
              props.advancedDirectives.hasProxy === true
                ? translate(STRINGS.YES)
                : translate(STRINGS.NO)
            }
          />
          <AppListItem
            title={<strong>{translate(STRINGS.PROXY_FIRST_NAME)}</strong>}
            trailing={props.advancedDirectives.firstName ?? <PatientDetailsNoValue />}
          />

          <AppListItem
            title={<strong>{translate(STRINGS.PROXY_LAST_NAME)}</strong>}
            trailing={props.advancedDirectives.lastName ?? <PatientDetailsNoValue />}
          />
          <AppListItem
            title={<strong>{translate(STRINGS.PROXY_PHONE)}</strong>}
            trailing={
              fmap(props.advancedDirectives.phoneNumber, (x) => formatPhone(x)) ?? (
                <PatientDetailsNoValue />
              )
            }
          />
        </AppList>
      </AppCardContent>
    </AppCard>
  );
};
